import { AxiosInstance } from 'axios/index';
import { Author } from '@shared/types/defaults';
import { ModuleParam } from '@src/api/types.ts';

const usersUrl = '/users/';

export class UsersApi {
  constructor(private instance: AxiosInstance) {}

  public async getAuthors(params: ModuleParam) {
    return this.instance
      .get<Array<AuthorFavorite>>(usersUrl + `authors/`, { params })
      .then((res) => res.data);
  }

  public async addAuthorToFavorites(params: UpdateAuthorFavorite) {
    return this.instance.post(usersUrl + `authors/${params.id}/favorite/`).then((res) => res.data);
  }

  public async removeAuthorFromFavorites(params: UpdateAuthorFavorite) {
    return this.instance
      .delete<Author[]>(usersUrl + `authors/${params.id}/favorite/`)
      .then((res) => res.data);
  }
}
export type UpdateAuthorFavorite = Pick<Author, 'id'>;

export type AuthorFavorite = Author & {
  favorite: boolean;
};

export type FavoriteAuthorAction = {
  author: number;
};
